---
headline: Privacy.
---

## In plain language

This site collects very little. We are an independent design studio, not a data business.

## What we collect

- **Inquiry forms.** When you fill out the contact form, we collect what you provide — your name, email, an optional phone number, project typology, location, and the body of your message. We use it to respond to you. We do not sell it. We do not share it.
- **Analytics.** We use PostHog to understand which pages get visited. PostHog stores aggregated session information in cookies. It does not record your session by default, and we have not enabled session recording. You can opt out via browser settings or your privacy tools of choice.
- **Server logs.** Cloudflare, who hosts this site, logs requests for security and performance. We do not have access to identify you individually from those logs.

## What we don't collect

- Third-party trackers, advertising pixels, or marketing-attribution networks
- Audio or video on any page
- Anything from the cinematic hero — the WebGL scene runs entirely in your browser

## Cookies

A single first-party PostHog cookie. No third-party cookies.

## Contact

Questions about privacy: <a href="mailto:brianellisondesigns@icloud.com" class="text-link">brianellisondesigns@icloud.com</a>.

This policy was last updated **2026-05-20**.
